import React from 'react';
import { Breadcrumb, Panel } from 'rsuite';
import DataTable from './DataTable';
import { useTranslation } from 'react-i18next';
const Page = () => {
  const { t } = useTranslation();
  return (
    <Panel
      header={
        <>
          <h3 className="title">{t('Holidays')}</h3>
          <Breadcrumb>
            <Breadcrumb.Item href="/">{t('Home')}</Breadcrumb.Item>
            <Breadcrumb.Item active>{t('Holidays')}</Breadcrumb.Item>
          </Breadcrumb>
        </>
      }
    >
      <DataTable />
    </Panel>
  );
};

export default Page;
